export default __webpack_public_path__ + "static/media/PIKO.cd29f4ab.svg";